import { render, staticRenderFns } from "./SpecialWinnerListCard.vue?vue&type=template&id=2f637cc6&"
import script from "./SpecialWinnerListCard.vue?vue&type=script&lang=js&"
export * from "./SpecialWinnerListCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports